<template>
  <div>
    <div class="info_preamble_box">
      <p class="p1">{{ $t('home.yinjicode') }}：<span>{{ preamble_code }}</span></p>
      <div class="table_box"
           v-show="!nodata">
        <ul>
          <li v-for="(item,index) in infolist"
              :key="index">
            <p class="one-txt-cut">{{$t('logoff.tourText2')}}: {{ item.game }}</p>
            <p class="one-txt-cut">{{$t('logoff.tourText3')}}: {{ item.role_name}}</p>
            <p class="one-txt-cut">{{$t('logoff.tourText4')}}: {{item.role_id}}</p>
            <p class="one-txt-cut">{{$t('logoff.tourText5')}}: {{ item.level }}</p>
          </li>

        </ul>
      </div>
      <div class="nomore"
           v-show="nodata">
        <img src="../../assets/images/nomore.png"
             alt="">
        <p>{{$t('preamble.tx10')}}</p>
      </div>
      <p class="p2">{{$t('preamble.tx11')}}</p>
      <li class="form_item form_submit"
          @click="bindlClick"
          ref='form_submit'>
        {{$t('preamble.tx12')}}
      </li>
    </div>
  </div>
</template>

<script>
import { appPostMessage } from '@/utils/communication'
import { getSessionStorage, setSessionStorage } from '@/utils/stage'
import { preamble_code_transfer } from '@/api/login'
export default {
  data() {
    return {
      configData: '',
      accountStorage: '',
      preamble_code: '',
      infolist: [],
      nodata: false,
    }
  },
  mounted() {
    let that = this
    window['getToken'] = (url) => {
      that.bind(url) // 这个也就是我定义的方法
    }
  },
  created() {
    this.init()
  },
  methods: {
    init() {
      const preamblecode = JSON.parse(getSessionStorage('playInfo'))
      this.infolist = JSON.parse(getSessionStorage('userInfo'))
      this.nodata = this.infolist.length > 0 ? false : true
      this.preamble_code = preamblecode.preamble_code

      this.configData = JSON.parse(getSessionStorage('message'))
    },
    bindlClick() {
      const accesstoken = JSON.parse(
        getSessionStorage('preambleInfo')
      ).access_token
      if (accesstoken) {
        const token = { access_token: accesstoken }
        this.bind(token)
      } else {
        const msg = { code: 20, data: '' }
        appPostMessage(msg)
      }
    },
    bind(token) {
      const play = JSON.parse(getSessionStorage('playInfo'))
      //   const access_token = token.access_token
      const msg = Object.assign(
        JSON.parse(JSON.stringify(this.configData)),
        play,
        token
      )
      preamble_code_transfer(msg).then((res) => {
        const bindInfo = JSON.stringify(res.data)
        this.$router.push({ path: '/bindPreamble' })
        setSessionStorage('bindInfo', bindInfo)
      })
    },
  },
}
</script>

<style lang="less" scoped>
.info_preamble_box {
  width: 100%;
  padding: 30/75rem;
  height: 100%;
  box-sizing: border-box;
  position: relative;
  p {
    font-size: 28/75rem;
    font-weight: 400;
    color: #575757;
    margin-bottom: 30/75rem;
  }
  .p2 {
    margin-top: 20/75rem;
    font-weight: 400;
    font-size: 24/75rem;
    color: #575757;
    position: fixed;
    bottom: 105/75rem;
  }
  .table_box {
    width: 610/75rem;
    margin: 0 auto;
    overflow: hidden;
    height: calc(100vh - 240px);
    ul {
      width: 100%;
      height: 100%;
      overflow: auto;
      li {
        width: 610/75rem;
        margin-bottom: 10/75rem;
        height: 200/75rem;
        border-radius: 6px 6px 6px 6px;
        border: 1px solid #c7c7c7;
        padding: 20/75rem 35/75rem;
        box-sizing: border-box;

        font-size: 28/75rem;
        font-family: PingFang SC-Bold, PingFang SC;
        font-weight: bold;
        margin-bottom: 20/75rem;
        p {
          margin: 0;
          color: #575757;
          line-height: 40/75rem;
        }
      }
    }
  }
  .form_submit {
    width: 690/75rem;
  }
  .nomore {
    width: 500/75rem;
    height: 300/75rem;
    position: absolute;
    left: 50%;
    top: 300/75rem;
    transform: translateX(-50%);
    img {
      width: 400/75rem;
      margin: 0 auto;
    }
    p {
      text-align: center;
    }
  }
}
</style>